<template>
  <div class="csList">
    <div class="select">
       <el-form ref="form" :model="request" label-position="right">
          <el-form-item><el-input v-model="request.subjectName" placeholder="代理名称" style="width:200px" clearable></el-input></el-form-item>
          <el-form-item><el-input v-model="request.phone" placeholder="代理电话" style="width:200px" clearable></el-input></el-form-item>
          <el-form-item>
          <el-button style="background-color:#A9F5F2;margin: 0" icon="el-icon-search" @click="getAllCs">搜索</el-button>
          <el-button style="background-color:#A9F5A9" icon="el-icon-refresh" @click="reset">重置</el-button>
          <el-button style="background-color:#A9F5A9" icon="el-icon-refresh" @click="addCs">新增代理</el-button>
        </el-form-item>
       </el-form>
    </div>
    <div class="tableData">
      <el-table :data="response.data"  v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading"
                style="margin:auto;width:calc(100% - 30px)" height="715" border :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.25%' }"
                :header-cell-style="{background:'#01DFD7',color:'#fff'}" element-loading-background="rgba(0.8, 0, 0, 0.3)">
        <el-table-column label="代理编号" align="center" prop="code" width="150"></el-table-column>
        <el-table-column label="代理类型" align="center" prop="typeStr" width="100"></el-table-column>
        <el-table-column label="代理名称" align="center" width="200" prop="subjectName"></el-table-column>
        <el-table-column label="代理电话" align="center" prop="phone" width="150"></el-table-column>
        <el-table-column label="地区" align="center" width="200">
          <template slot-scope="scope">{{scope.row.provinceStr}}{{scope.row.cityStr}}{{scope.row.areaStr}}</template>
        </el-table-column>
        <el-table-column label="详细地址" align="center" prop="address"></el-table-column>
        <el-table-column label="是否分润" align="center" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.rewardFlag === '1'">开通</el-tag>
            <el-tag v-else>未开通</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="分润比例" align="center" prop="rewardPercent" width="100"></el-table-column>
        <el-table-column label="账号状态" align="center" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.delFlag === '0'">正常</el-tag>
            <el-tag v-else>冻结</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="账号操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button @click="modifyCs(scope.row.code)" type="warning" plain size="small">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="query.current" :total="response.total" @current-change="currenChangeHandle" layout="total, prev, pager, next, jumper" :page-size="query.size"/>
      <add-cs v-if="addCsDialog" ref="addCs" @add-succeed="addSucceed"></add-cs>
      <modify-cs v-if="modifyCsDialog" ref="modifyCs" @modify-succeed="modifySucceed"></modify-cs>
    </div>
  </div>
</template>

<script>
import {getCsList} from '../../api/usermanagement/csList.js'
import AddCs from '../relation/addCs.vue'
import ModifyCs from './modifyCs.vue'
export default {
  name: 'CsManagement',
  components: {AddCs,ModifyCs},
  data() {
    return {
      request: {
        subjectName: '',
        phone: '',
        current: '',
        size: '',
      },
      global: '',
      loading: false,
      query: {current: 1,size: 15},
      response: {data: [],total: 0},
      addCsDialog: false,
      modifyCsDialog: false
    }
  },
  methods:{
    /**
     * 查询代理列表
     */
    getAllCs(){
      this.request.current = this.query.current;
      this.request.size = this.query.size;
      getCsList(this.request).then(result=>{
        this.response.data = result.data.records;
        this.response.total = result.data.total;
      })
    },

    /**
     * 页码改变触发事件
     */
    currenChangeHandle(value) {
      this.query.current = value;
      this.getAllCs()
    },
    /**
     * 重置
     */
    reset(){
      this.request.subjectName = "";
      this.request.phone = "";
      this.query.current = 1;
      this.getAllCs();
    },

    /**
     * 添加代理
     */
    addCs(){
      this.addCsDialog = true;
      this.$nextTick(() =>{
        this.$refs.addCs.init();
      })
    },

    /**
     * 添加成功重新请求
     */
    addSucceed(){
      this.getAllCs();
    },

    /**
     * 编辑代理
     */
    modifyCs(id){
      this.modifyCsDialog = true;
      this.$nextTick(()=>{
        this.$refs.modifyCs.init(id)
      })
    },

    /**
     * 修改成功重新请求
     */
    modifySucceed(){
      this.getAllCs();
    }
  },
  mounted() {
    this.getAllCs();
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    }
  },
}
</script>
<style scoped>
body {
  margin: 0px;
}

.csList {
  width: 100%;
  height: 100%;
}
.el-form {
  float: left;
}

.el-form-item {
    display: inline-block !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/usermanagement/cslist.vue